import React, { useRef } from 'react';
import { Multiselect } from "multiselect-react-dropdown";
import { ct } from '../../constant-Utils';



// Backup if no option are specified
const names = [
    {
        "name": "Classical",
        "value": 1
    }
];

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function MultipleSelect(props) {
    

  let listOptionsMap = {};
  const multiSelectRef = useRef(null)
  const [listOptions, setListOptions] = React.useState(props.options || names);
  const [personName, setPersonName] = React.useState(props.selectedOptions || []);
  const clearSelection = () => {
    setPersonName([]);
    props.clearFiltersCB();
  }
  const handleChange = (value) => {
    // const {
    //   target: { value },
    // } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );

    if (value.length > 0) {
        const OptionsObjectList = listOptions.filter(i => i.name == value[value.length - 1]);
        const indexofOptionsObject = listOptions.indexOf(OptionsObjectList[0]);
        listOptionsMap[`${indexofOptionsObject}`] = OptionsObjectList[0];        
    }

    props.onChange(value, `${props.name}[${props.parent}]`, listOptionsMap);

    
  };

  function getStyles() {
    return {
      fontSize: '14px'
    };
  }
  const handleInstrumentList = (e) => {
    try {
      const isSpace = e?.split(" ")?.length > 1;
      let key = e;
      if (isSpace) {
        key = e.replace(/ /g, "_");
      }
      return ct(`rta-trmc.mixer.instrumentList.${key?.toLowerCase()}`);
    } catch (error) {
      return e;
    }

  }

  return (
    <div className='inputWrapper'>
      <Multiselect
      ref={multiSelectRef}
        hidePlaceholder={true}
        placeholder={ct("rta-trmc.rtaInviteModal.select")}
        options={listOptions.map((data) => ({ key: data.name, cat: handleInstrumentList(data.name) }))}
      closeIcon={<i className="fa fa-times-circle-o" aria-hidden="true"></i>}
        displayValue="cat"
      id="multiple-select-dropdown"
      style={ {chips: {background: "transparent linear-gradient(99deg, var(--theme-gradient-start-color) 1%,var(--theme-gradient-end-color) 99%) 0% 0% no-repeat padding-box" }, searchBox: { border: "none", "border-radius": "0px" } }}
        selectedValues={personName.map((data) => ({ key: data, cat: handleInstrumentList(data) }))}
      onSelect={e=>{handleChange(e.map(e=>e.key))}}
      avoidHighlightFirstOption
      onRemove={(e)=>{
        handleChange(e.map(e=>e.key));
      }}
      closeOnSelect
    />
    {props.name == 'Instrument'? <button id="instrument-clear-control" className='hidden' onClick={()=> clearSelection()}>clear</button>: null}
    </div>
  );
}